import { render, staticRenderFns } from "./ResourceTypesDependencesList.vue?vue&type=template&id=fcdf6628&scoped=true&"
import script from "./ResourceTypesDependencesList.vue?vue&type=script&lang=ts&"
export * from "./ResourceTypesDependencesList.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceTypesDependencesList.vue?vue&type=style&index=0&id=fcdf6628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcdf6628",
  null
  
)

export default component.exports